export default {
  props: ['value', 'content'],

  data () {
    return {
      option: this.value
    };
  },

  watch: {
    value (value) {
      this.option = value;
    },

    option (value) {
      this.$emit('input', value);
    }
  }
}